export default __webpack_public_path__ + "static/media/bannerplus.814d498b.svg";